import React from 'react';

interface Identifiers {
  id: string;
  className?: string;
}

interface RadioInteractions {
  onClick?: (checkedValue: string) => void;
}

interface RadioOptions {
  checked?: boolean;
  disabled?: boolean;
  identifiers: Identifiers;
  label: string;
  value: string;
  labelClassName?: string;
  inputClassName?: string;
}

interface ErrorOptions {
  error: string;
  errorClassName?: string;
}

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: Identifiers;
  interactions?: RadioInteractions;
  radioOptions: RadioOptions[];
  errorOptions?: ErrorOptions;
}

const RadioGroupColumn: React.FC<RadioProps> = ({
  identifiers: { id, className = '' },
  interactions: { onClick } = {},
  radioOptions,
  errorOptions: { error, errorClassName = '' } = {},
  ...props
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onClick?.(value);
  };

  return (
    <div
      className={`max-md:mt-[1rem] flex flex-col items-start justify-between gap-[1.2rem] ${className}`}
      id={id}
    >
      {radioOptions.map(option => (
        <label
          htmlFor={option.identifiers.id}
          className={`flex items-start self-start justify-start gap-[0.8rem] md:text-[1.6rem] text-[1.4rem] leading-[1.4] font-normal text-black ${option?.labelClassName}`}
        >
          <input
            disabled={option?.disabled}
            type="radio"
            id={option.identifiers.id}
            value={option.value}
            checked={option.checked}
            onChange={e => !option.disabled && handleChange(e)}
            className={`w-8 h-6 mt-1 border border-[#2962FF] accent-[#2962FF] ${option?.inputClassName}`}
            {...props}
          />
          {option.label}
        </label>
      ))}
      {error && (
        <div
          className={`text-[#eb5757] text-base font-semibold mt-2 whitespace-nowrap ${errorClassName}`}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default RadioGroupColumn;
